<template v-slot:default="{ hover }">
  <v-hover>
    <template v-slot:default="{ hover }">
      <span style="display:inline-block" class="status-avatar" hover>
        <ProfilePicturesDialog :dialog="dialog" :user="user" @open-close-picture-profile-dialog="openClosePictureProfileDialog"/>
        <v-tooltip bottom :disabled="!displayChatStatus">
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-badge avatar left bottom color="rgba(255, 0, 0, 0)" offset-x="10" offset-y="10">
                <template v-slot:badge>
                  <v-icon :color="statusColor" :class="statusClass" :size="badgeSize">{{ callStatusIcon }}</v-icon>
                </template>
                <v-badge avatar right bottom color="rgba(255, 0, 0, 0)" offset-x="10" offset-y="10">
                  <template v-slot:badge>
                    <v-icon v-if="displayChatStatus" :color="chatStatusColor" class="avatar-badge bottom-right" :size="badgeSize">{{ chatStatusIcon }}</v-icon>
                  </template>
                  <v-avatar class="avatar-image" :size="avatarSize">
                    <v-img v-if="picture" :src="picture">
                      <template v-slot:placeholder>
                        <v-icon class="placeholder">mdi-account</v-icon>
                      </template>
                    </v-img>
                    <v-img v-else><v-icon class="placeholder">mdi-account</v-icon></v-img>
                    <v-fade-transition>
                      <v-overlay v-if="hover && showEditHover" absolute>
                        <v-btn icon @click="openClosePictureProfileDialog()">
                          <v-icon dark>mdi-pencil</v-icon>
                        </v-btn>
                      </v-overlay>
                    </v-fade-transition>
                  </v-avatar>
                </v-badge>
              </v-badge>
            </div>
          </template>
          <div>{{ $t(chatStatusTextKey) }}</div>
          <div v-if="chatCustomStatusText">{{ chatCustomStatusText }}</div>
        </v-tooltip>
      </span>
    </template>
  </v-hover>
</template>

<script>
import { mapGetters } from 'vuex'
import ChatPresence from 'Store/class/chat/presence'
import ProfilePicturesDialog from '@/components/user_picture_profiles/index.vue'

export default {
  name: 'buddies-status-avatar',
  components: {
    ProfilePicturesDialog
  },
  data () {
    return {
      dialog: false
    }
  },
  props: {
    user: { type: Object, default: null },
    avatarSize: { type: String, default: '48px' },
    badgeSize: { type: String, default: '16px' },
    showTooltip: { type: Boolean, default: true },
    showChatStatus: { type: Boolean, default: true },
    showEditHover: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters({
      chatUsers: 'chat/users',
      presences: 'chat/presences',
      canShowState: 'permissions/showCallState'
    }),
    isOnCall () {
      return this.user?.isOnCall
    },
    badgeStyle () {
      return {
        '--avatar-size': this.avatarSize,
        '--badge-size': this.badgeSize
      }
    },
    presence () {
      const presence = this.presences.find((presence) => this.username === presence.userId) ?? { status: 'offline', statusText: null }
      return presence
    },
    username () {
      return (
        this.chatUser?.chat_username /* chat/users */ ||
        this.user?.rocketUsername /* currentUser/currentUser */
      ) ?? null
    },
    extension () {
      return (this.user?.exten ?? this.user?.extension) ?? null
    },
    mgmPicture () {
      return this.user?.pictureProfileUrl || null
    },
    chatPicture () {
      return this.chatUser?.chat_picture_profile
    },
    picture () {
      return this.mgmPicture || this.chatPicture || '/default_picture_profile.png'
    },
    statusColor () {
      return this.user?.statusColor || 'grey lighten-1'
    },
    statusTextKey () {
      return this.user?.statusTextKey || 'offline'
    },
    statusClass () {
      let ret = 'avatar-badge bottom-left '
      if (!this.canShowState) ret += 'permission-deny'
      else if (this.user?.isRinging) ret += 'status-ringing'
      else if (this.isOnCall) ret += 'status-oncall'
      else if (this.user?.isOnline) ret += 'status-online'
      else if (this.user?.isOffline) ret += 'status-offline'
      else if (this.user?.isBusy) ret += 'status-busy'
      else if (this.user?.isAway) ret += 'status-away'
      else ret += 'status-unknown'
      return ret
    },

    chatUser () {
      return this.chatUsers.find((chat) => chat.exten === this.extension)
    },
    chatStatusColor () {
      return ChatPresence.statusColor(this.presence)
    },
    chatStatusIcon () {
      return ChatPresence.statusIcon(this.presence)
    },
    chatStatusTextKey () {
      if (this.isOnCall) return 'buddy.status.oncall'
      else if (this.user?.isRinging) return 'buddy.status.ringing'
      return ChatPresence.statusTextKey(this.presence)
    },
    callStatusIcon () {
      if (this.isOnCall) return 'mdi-phone-in-talk'
      else if (this.user?.isRinging) return 'mdi-phone-ring'
      return 'mdi-circle'
    },
    chatCustomStatusText () {
      return this.presence.statusText
    },
    displayChatStatus () {
      return this.showTooltip && this.showChatStatus && this.chatUser
    }
  },
  methods: {
    openClosePictureProfileDialog: function () {
      this.dialog = !this.dialog
    }
  }
}
</script>

<style scoped>
.placeholder {
  border-radius:50%;
  border:2px solid grey;
}
</style>
